import { AudioMixType, Episode, Movie, MovieDetails, ResolutionType } from './Asset';

export enum VODAssetEntitlementState {
    ENTITLED = 'entitled',
    SHOULD_RENT = 'should_rent',
    SHOULD_SUBSCRIBE = 'should_subscribe',
    SHOULD_BUY = 'should_buy',
    NOT_WATCHABLE = 'not_watchable',
}

export enum TVAssetEntitlementState {
    ENTITLED = 'entitled',
    SHOULD_BUY_BASIC_REPLAY_WINDOW = 'should_buy_basic_replay_window', // 2 -> TimeMachine
    SHOULD_BUY_EXTENDED_REPLAY_WINDOW = 'should_buy_extended_replay_window', // 3 -> TimeMachinePlus
    SHOULD_SUBSCRIBE_CHANNEL = 'should_subscribe_channel', // 1
    SHOULD_SUBSCRIBE = 'should_subscribe',
}

export enum PurchasedProductType {
    TIME_MACHINE = 'TimeMachine',
    TIME_MACHINE_PLUS = 'TimeMachinePlus',
    SUBSCRIPTION = 'Subscription',
}

export enum EntitlementState {
    ENTITLED = 'Entitled',
    NOT_ENTITLED = 'NotEntitled',
}

export enum ProductType {
    TRANSACTION = 'Transaction',
    FREE = 'Free',
    SUBSCRIPTION = 'Subscription',
}

type PurchasedProductAlt = {
    // wut?
    EntitlementState: EntitlementState;
    Name: string;
    Type: ProductType;
    id: string;
};

export type PurchasedProduct = {
    type: PurchasedProductType | string;
    state: string;
    product: PurchasedProductAlt[];
};

export type ContentProduct = {
    id?: string;
    productId: string;
    productName: string;
    productCode: string;
    currency?: string;
    listPrice?: number;
    rentalPeriodInMinutes?: number;
    description?: string;
    audios?: string[];
    subtitles?: string[];
    audioMixType?: AudioMixType;
    availabilityEnd?: number;
    isBuyOffer: boolean;
    catalog_id?: string;
};

export type Offer = ContentProduct & {
    offerId: string;
    offerValue: number;
    rentalPeriod: string;
    resolution: ResolutionType;
};

export type RentData = {
    productId: string;
    offerId: string;
};

export type SubscribeType = 'Product' | 'Channel' | 'Listing';

export type SubscribeCapability = 'RECORDING' | 'REPLAY';

export type SubscribeData = {
    code: string;
    type: SubscribeType;
    assetId?: string;
    metaData?: Episode | Movie | MovieDetails;
    image?: string;
    capability?: SubscribeCapability;
};

export type SubscribeOption = {
    name: string;
    tags: string[];
    price: number;
    productId: number;
    poster: string;
    description: string;
    assetId?: string;
    packageId?: string;
};

export type OrderSubscription = {
    productId: number;
};

export type ServiceType = 'TV_PACKAGE' | 'TV_CHANNEL_BUNDLE' | 'TV_CHANNEL' | 'TV_ADDITIONS';

export type ServicePrice = {
    value: number;
    months: number;
};

export type ServiceImageByType = {
    poster?: string;
};

export type Service = {
    id: number;
    name: string;
    type: ServiceType;
    description: string;
    price: ServicePrice;
    image_by_type: ServiceImageByType;
    required_services: number[];
};

export type ServicePurchaseError = {
    error_code: 'INVALID_PIN' | 'UNKNOWN_ERROR';
    error_description: string;
};
